import { useCallback, useEffect, useRef, useState } from 'react';

const TIMER_UPDATE_INTERVAL_MS = 100;

export const formatMazeElapsedTime = (elapsedMs: number) => {
  const totalSeconds = Math.floor(Math.max(0, elapsedMs) / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
};

export const useMazeTimer = () => {
  const [elapsedMs, setElapsedMs] = useState(0);
  const startedAtRef = useRef<number | null>(null);
  const intervalRef = useRef<number | null>(null);

  const clearTimer = useCallback(() => {
    if (intervalRef.current !== null) window.clearInterval(intervalRef.current);
    intervalRef.current = null;
  }, []);

  const start = useCallback(() => {
    clearTimer();
    startedAtRef.current = Date.now();
    setElapsedMs(0);
    intervalRef.current = window.setInterval(() => {
      if (startedAtRef.current !== null) setElapsedMs(Date.now() - startedAtRef.current);
    }, TIMER_UPDATE_INTERVAL_MS);
  }, [clearTimer]);

  const stop = useCallback(() => {
    if (startedAtRef.current !== null) setElapsedMs(Date.now() - startedAtRef.current);
    startedAtRef.current = null;
    clearTimer();
  }, [clearTimer]);

  useEffect(() => clearTimer, [clearTimer]);

  return { elapsedMs, start, stop };
};
